import { noop } from 'utils/noop';
import { getNoop } from 'utils/noop';
import {
    TrackingContextType,
    TrackingContextStateType,
} from './TrackingContext.types';

export const defaultTrackingState: TrackingContextStateType = {
    mapOfSamplesPlayed: new Map(),
    mapOfDemosPlayed: new Map(),
};

export const defaultTrackingContext: TrackingContextType = {
    state: defaultTrackingState,
    trackingDispatch: noop,
    getSampleCollectionInitializedTracker: () => noop,
    getPackCardPlayButtonClickTracker: getNoop,
    getPackPlayButtonClickTrackerV2: getNoop,
};
